import { useEffect, useState } from "react";
import { X } from "lucide-react";

import { api, apiError } from "@/lib/api";
import { boliviaDateInputWithOffset, boliviaTodayInput } from "@/lib/dateTime";

const nextWeek = () => boliviaDateInputWithOffset(7);

export default function PlanReservationModal({ lot, onClose, onReserved }) {
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState("");
  const [amount, setAmount] = useState("");
  const [expiresAt, setExpiresAt] = useState(nextWeek());
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/clients").then((response) => setClients(response.data));
  }, []);

  const reserve = async (event) => {
    event.preventDefault();
    try {
      const response = await api.post(`/lots/${lot.id}/reservation`, {
        client_id: clientId,
        monto_reserva: Number(amount),
        fecha_vencimiento: expiresAt,
        observaciones: notes,
      });
      onReserved(response.data);
      onClose();
    } catch (requestError) {
      setError(apiError(requestError));
    }
  };

  return (
    <div className="lot-operation-modal" data-testid="plan-reservation-modal">
      <form className="lot-operation-form" data-testid="plan-reservation-form" onSubmit={reserve}>
        <button
          aria-label="Cerrar reserva"
          className="icon-button modal-close"
          data-testid="close-plan-reservation"
          onClick={onClose}
          type="button"
        >
          <X size={18} />
        </button>
        <span className="eyebrow">RESERVA DESDE PLANO</span>
        <h2>Manzano {lot.manzano} · Lote {lot.lote}</h2>
        <label htmlFor="plan-reservation-client">Cliente</label>
        <select
          data-testid="plan-reservation-client"
          id="plan-reservation-client"
          onChange={(event) => setClientId(event.target.value)}
          required
          value={clientId}
        >
          <option value="">Selecciona un cliente</option>
          {clients.map((client) => (
            <option key={client.id} value={client.id}>
              {`${client.nombre} · ${client.ci}`}
            </option>
          ))}
        </select>
        <label htmlFor="plan-reservation-amount">Monto de reserva</label>
        <input
          data-testid="plan-reservation-amount"
          id="plan-reservation-amount"
          min="0.01"
          onChange={(event) => setAmount(event.target.value)}
          required
          step="0.01"
          type="number"
          value={amount}
        />
        <label htmlFor="plan-reservation-expiry">Vence el</label>
        <input
          data-testid="plan-reservation-expiry"
          id="plan-reservation-expiry"
          min={boliviaTodayInput()}
          onChange={(event) => setExpiresAt(event.target.value)}
          required
          type="date"
          value={expiresAt}
        />
        <label htmlFor="plan-reservation-notes">Observaciones</label>
        <textarea
          data-testid="plan-reservation-notes"
          id="plan-reservation-notes"
          onChange={(event) => setNotes(event.target.value)}
          value={notes}
        />
        {error && <p className="form-error" data-testid="plan-reservation-error">{error}</p>}
        <button className="primary-button" data-testid="confirm-plan-reservation" type="submit">
          Confirmar reserva
        </button>
      </form>
    </div>
  );
}
